import { Sparkles } from 'lucide-react'
import { Badge } from '@/shared/components/ui/badge'

export function UpgradeBadge() {
  return (
    <Badge
      variant="outline"
      className="gap-1 border-amber-400 bg-amber-50 text-amber-700 dark:bg-amber-900/20 dark:text-amber-400 text-[10px] px-1.5 py-0.5 shrink-0"
    >
      <Sparkles className="h-2.5 w-2.5" />
      Upgrade
    </Badge>
  )
}
